/**
 * Hook that returns whether the current device is mobile based on the 'data-is-mobile' attribute.
 * @returns {boolean} `true` if the current device is mobile, `false` otherwise.
 */
var useIsMobile = function () {
  if (typeof window !== 'undefined') {
    return document.documentElement.getAttribute('data-is-mobile') === 'true';
  }
  return false;
};

export { useIsMobile };
//# sourceMappingURL=useIsMobile.js.map
